import styled, { css } from "styled-components";
import { type PropsWithChildren, CSSProperties } from "react";

type ChipColor = "primary" | "success" | "brand";

export type ChipProps = PropsWithChildren<{
	color?: ChipColor;
	flexible?: boolean;
	style?: CSSProperties;
	interactive?: boolean;
}>;

const ChipWrapper = styled.div<{
	$color: ChipColor;
	$flexible: boolean;
	$interactive: boolean;
}>`
	display: flex;
	flex: ${({ $flexible }) => ($flexible ? 1 : 0)};
	justify-content: center;
	pointer-events: ${({ $interactive }) => ($interactive ? "auto" : "none")};
`;

const ChipInner = styled.div<{ $color: ChipColor }>`
	display: flex;
	white-space: nowrap;
	flex: 0;
	padding: 0.25rem 1rem;
	border-radius: 1000px;
	flex-direction: row;
	cursor: pointer;

	${({ $color }) => {
		switch ($color) {
			case "primary":
				return css`
					color: var(--primary);
					background: rgba(var(--primary), 0.08);
				`;
			case "success":
				return css`
					color: var(--on-success-container);
					background: rgba(var(--success-container), 0.08);
					${ChipWrapper}:hover & {
						background: var(--success-container);
					}
				`;
			case "brand":
				return css`
					/* Add brand-specific styles here */
				`;
			default:
				return "";
		}
	}}
`;

export const Chip = ({
	color = "primary",
	flexible = false,
	style,
	children,
	interactive = true,
}: ChipProps) => {
	return (
		<ChipWrapper $color={color} $flexible={flexible} $interactive={interactive}>
			<ChipInner $color={color} style={style}>
				{children}
			</ChipInner>
		</ChipWrapper>
	);
};
